
import $axios from "@/api";

const state = () => ({
    data:[]
})

const mutations = {
    SET_DATA(state, data){
        state.data = data
    },
}

const actions = {
    async listTags({commit}){
        try{
            const response = await $axios.get("tags")
            commit("SET_DATA",response.data.data)
        }catch(err){    
            console.log(err)
        }
    },
}

export default {
    namespaced: true,   
    mutations,
    actions,
    state,
}
